import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState = {
  isVisibleRecommendApps: true,
  isVisibleDateAndTime: true,
  embeddedBanner: true,
  isVisibleBannerShiprocketPro: true,
  isVisibleBannerShiprocket: true,
  isVisibleBannerCheckoutExt: true,
  isVisibleBannerSetupAppearance: true,
  isVisibleBannerGeneralSettings: true,
  isVisibleWhatIsNewSection: true,
  isVisibleBannerInfoInNewRule: true,
  isVisiblePromotions: true,
  isVisibleBannerInfoInTranslation: true,
  isVisibleBannerLimitAnalyticForStandard: true,
  isVisibleBannerLifetime: true,
};

export const bannerSlice = createSlice({
  name: `commonSetting`,
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    handleVisibleBanner: (
      state,
      action: PayloadAction<{
        key: keyof typeof initialState;
        value: boolean;
      }>,
    ) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});

// Other code such as selectors can use the imported `RootState` type
export const bannerSelector = createSelector(
  (state: RootState) => state.banner,
  (state) => state,
);

export default bannerSlice;
